const emojiOptions = [
    '🔮',
    '🎱',
    '🤖',
    '🗣️',
    '💬',
    '💭',
    '🎲'
]

/** Returns an oracle message randomly generated on the server */
function getOracleMessage() {
    return window.sir.oracleMessage || false
}

/** Returns an emoji from the emoji list */
function getEmoji() {
    return emojiOptions[Math.floor(Math.random() * emojiOptions.length)];
}

/** Outputs an oracle message to the console */
export default function displayOracleMessage() {
    const oracleMessage = getOracleMessage()

    if (!oracleMessage) return

    const italic    = 'font-style: italic;'
    const bold      = 'font-weight: bold;'
    const medium    = 'font-size: 1.0rem;'
    const large     = 'font-size: 3rem;'
    const color     = 'color: #000;'
    const shadow    = 'text-shadow: ' + [
        'rgb(255, 255, 255) 0px 0px 2px',     // white
        'rgb(255, 255, 255) 0px 0px 2px',     // white
        'rgb(255, 255, 255) 0px 0px 3px',     // white
        'rgb(255, 255, 255) 0px 0px 3px',     // white
        'rgb(41, 254, 224)  -5px -2px 0.5rem',  // top-left     green
        'rgb(48, 117, 255)   3px -3px 0.5rem',  // top-right    blue
        'rgb(255, 48, 183)   5px  2px 0.5rem',  // bottom-right red
        'rgb(250, 255, 48)  -3px  3px 0.5rem',  // bottom-left  yellow
    ].join(', ') + ';'

    const emoji = getEmoji()
    console.message('%cWelcome weary traveller.\r\n\tHeed the words of the console oracle…', `${medium}${italic}`)
    console.message(
        `%c${emoji}%c ${oracleMessage} %c${emoji}`,
        large,
        `${shadow}${large}${bold}${color}`,
        large
    )
}
